import PropTypes from 'prop-types'
import { useState } from 'react'
import 'video.js/dist/video-js.css'
import './vjs-moal.css'

const NotificationBar = ({ onClick, cta, message, type }) => {
  let bgColor = ''
  switch (type) {
    case 'error':
      bgColor = 'bg-red-600'
      break
    case 'warning':
      bgColor = 'bg-amber-600'
      break
    default:
      bgColor = 'bg-nuetral-600'
  }
  const [show, setShow] = useState(true)
  const handleShow = () => {
    setShow(!show)
  }

  if (!show) {
    return null
  }

  return (
    <div
      className={`absolute z-10 flex w-fit my-2 ml-2 shadow-md shadow-black/25 justify-center items-center gap-2 ${bgColor} p-3 rounded-xl`}
    >
      <p className="text-xs lg:text-base font-bold text-white flex items-center gap-2">
        {message}
      </p>
      {onClick && cta && (
        <button className="notif-bar-button" onClick={onClick}>
          {cta}
        </button>
      )}
      {type !== 'error' && (
        <button onClick={() => handleShow()} className="notif-bar-dismiss">
          Dismiss
        </button>
      )}
    </div>
  )
}

NotificationBar.propTypes = {
  message: PropTypes.string.isRequired,
  cta: PropTypes.string,
  onClick: PropTypes.func
}

export default NotificationBar
